import React from 'react'
import { Box } from '@mui/material'
import { ProjectWithComments } from '../../../../types/project'
import ProjectDetailsForm from './ProjectDetailsForm'
import TeamSection from './TeamSection'
import { StagesManagement } from './StagesManagement'
import ProjectItemsSection from './ProjectItemsSection'
import { AttachmentsSection } from './AttachmentsSection'
import CommentSection from './CommentSection'
import { LinkedTaskBoardsSection } from './LinkedTaskBoardSection'
import ProjectNameEditor from './ProjectNameEditor'

interface TabContentProps {
  activeTab: string
  project: ProjectWithComments
  onProjectUpdate: (updatedProject: ProjectWithComments) => void
  onOpenImageModal: (itemId: string, imageUrl?: string) => void
}

const TabContent: React.FC<TabContentProps> = ({
  activeTab,
  project,
  onProjectUpdate,
  onOpenImageModal
}) => {
  switch (activeTab) {
    case 'details':
      return (
        <Box>
          <ProjectNameEditor
            project={project}
          />
          <ProjectDetailsForm
            project={project}
            onProjectUpdate={onProjectUpdate}
          />
        </Box>
      )
    case 'team':
      return (
        <TeamSection
          projectId={project.id}
        />
      )
    case 'schedule':
      return (
        <Box>
          <StagesManagement
            project={project}
          />
        </Box>
      )
    case 'products':
      return (
        <Box>
          <ProjectItemsSection
            project={project}
            onProjectUpdate={onProjectUpdate}
            onOpenImageModal={onOpenImageModal}
          />
        </Box>
      )
    case 'attachments':
      return (
        <Box>
          <AttachmentsSection
            projectId={project.id}
            isList={false}
          />
        </Box>
      )
    case 'notes':
      return (
        <Box>
          <CommentSection
            projectId={project.id}
          />
        </Box>
      )
    case 'linked-tasks':
      return (
        <Box>
          <LinkedTaskBoardsSection
            projectId={project.id}
          />
        </Box>
      )
    default:
      return null
  }
}

export default TabContent
